import { gql } from "@apollo/client";

const SITEMAP = gql`
	query sitemap($region_url: String) {
		sitemap(region_url: $region_url) {
			h1
			url
		}
	}
`;

export default SITEMAP;
